"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compensation = exports.stickyContent = exports.content = exports.wrapper = exports.fadeIn = void 0;

var _util = require("../../../util");

const fadeIn = () => ({
  '0%': {
    opacity: '0%'
  },
  '100%': {
    opacity: '100%'
  }
});

exports.fadeIn = fadeIn;

const wrapper = ({
  theme,
  cssProps
}) => ({
  width: '100%',
  position: 'sticky',
  top: -1,
  background: (0, _util.color)(theme, 'background.default'),
  zIndex: cssProps.zIndex
});

exports.wrapper = wrapper;

const content = ({
  cssProps: {
    height
  }
}) => ({
  height
});

exports.content = content;

const stickyContent = ({
  cssProps: {
    height,
    animation
  }
}) => ({
  height,
  animation: animation ? "".concat(animation, " .5s linear") : 'none'
});

exports.stickyContent = stickyContent;

const compensation = ({
  cssProps
}) => ({
  marginTop: cssProps.height
});

exports.compensation = compensation;
//# sourceMappingURL=StickyElement.style.js.map